import React from 'react';
import {
  Container,
  Grid,
  Header,
  List,
  Icon,
  Divider,
} from 'semantic-ui-react';

import arrowRightSVG from '@plone/volto/icons/right-key.svg';
import arrowLeftSVG from '@plone/volto/icons/left-key.svg';

const Footer = () => {
  // You can move these to configuration or props later
  const importantLinks = [
    { title: 'Tender', url: '/en/tender' },
    { title: 'NAAC', url: '/en/naac' },
    { title: 'RTI', url: 'https://main.tifr.res.in/maincampus/rti.php' },
    { title: 'Academic Calendar', url: '/en/academic/course-schedule' },
    { title: 'Holiday List', url: '/en/holidays' },
  ];

  const memberLinks = [
    { title: 'SIRC Opac', url: 'https://sirc.tifrbng.res.in' },
    { title: 'Datanet', url: 'https://datanet.tifr.res.in/cam' },
    { title: 'Datanet 2.0', url: 'http://datanet2.tifr.res.in/cam' },
    { title: 'Intranet', url: 'https://intranet.tifrbng.res.in' },
    { title: 'CHSS Information', url: '/en/for-members/chss-information' },
    { title: 'Internal Committee', url: '/en/for-members/internal-committee' },
  ];

  const studentLinks = [
    { title: 'Campus Life', url: '/en/for-members/campus-life' },
    {
      title: 'Anti Ragging Committee',
      url: '/en/for-members/anti-ragging-committee',
    },
    {
      title: 'Student Grievance Cell',
      url: '/en/for-members/student-grievance-redressal-committee',
    },
    {
      title: 'Student Support Cell',
      url: '/en/for-members/student-support-cell',
    },
  ];

  const socialLinks = [
    {
      title: 'Facebook',
      icon: 'facebook',
      url: 'https://www.facebook.com/TIFRCAM',
    },
    { title: 'X', icon: 'twitter', url: 'https://x.com/TIFR_CAM' },
    {
      title: 'LinkedIn',
      icon: 'linkedin',
      url: 'https://www.linkedin.com/school/tifr-centre-for-applicable-mathematics---india/',
    },
    {
      title: 'Youtube',
      icon: 'youtube',
      url: 'https://www.youtube.com/user/TIFRCAM',
    },
  ];

  return (
    <footer className="custom-footer">
      {/* Layer 2 - Main Footer Content */}
      <div className="q container default footer-main">
        <Container>
          <Grid stackable columns={4}>
            <Grid.Row>
              {/* Important Links */}
              <Grid.Column width={3}>
                <Header as="h4" className="footer-header">
                  Important Links
                </Header>
                <List link className="footer-list">
                  {importantLinks.map((link, index) => (
                    <List.Item key={index}>
                      <a
                        href={link.url}
                        target="_blank"
                        className="footer-link"
                        rel="noreferrer"
                      >
                        {link.title}
                      </a>
                    </List.Item>
                  ))}
                </List>
              </Grid.Column>

              {/* For Members */}
              <Grid.Column width={3}>
                <Header as="h4" className="footer-header">
                  For Members
                </Header>
                <List link className="footer-list">
                  {memberLinks.map((link, index) => (
                    <List.Item key={index}>
                      <a href={link.url} className="footer-link">
                        {link.title}
                      </a>
                    </List.Item>
                  ))}
                </List>
              </Grid.Column>

              {/* Student Corner */}
              <Grid.Column width={3}>
                <Header as="h4" className="footer-header">
                  Student Corner
                </Header>
                <List link className="footer-list">
                  {studentLinks.map((link, index) => (
                    <List.Item key={index}>
                      <a href={link.url} className="footer-link">
                        {link.title}
                      </a>
                    </List.Item>
                  ))}
                </List>
              </Grid.Column>

              {/* Social Links */}
              <Grid.Column width={3}>
                <Header as="h4" className="footer-header">
                  Follow Us
                </Header>
                <List link className="footer-list">
                  {socialLinks.map((link, index) => (
                    <List.Item key={index}>
                      <a
                        href={link.url}
                        target="_blank"
                        className="footer-link"
                        rel="noreferrer"
                      >
                        {link.title}
                      </a>
                    </List.Item>
                  ))}
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>

      {/* Layer 1 - Bottom Footer */}
      <div className="footer-bottom">
        <Container>
          <Grid stackable>
            <Grid.Row verticalAlign="middle">
              <Grid.Column width={12}>
                <div className="copyright">
                  &copy; Copyright {new Date().getFullYear()} TIFR Centre For
                  Applicable Mathematics
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>

      <style jsx>{`
        .custom-footer {
          background: #194a7a;
          color: white;
          margin-top: 30px;
        }

        .footer-main {
          padding: 2rem 0 1rem 0;
        }

        .footer-header {
          color: white !important;
          font-size: 16px !important;
          margin-bottom: 1.5rem !important;
          border-bottom: 2px solid rgba(255, 255, 255, 0.2);
          padding-bottom: 0.5rem;
        }

        .footer-header i.icon {
          margin-right: 0.5rem;
        }

        .footer-list {
          list-style: none;
          padding: 0;
        }

        .footer-list .item {
          margin-bottom: 0.3rem;
        }

        .footer-link {
          color: rgba(255, 255, 255, 0.9) !important;
          text-decoration: none;
          display: flex;
          align-items: center;
          transition: all 0.3s ease;
          font-size: 14px;
        }

        .footer-link:hover {
          color: rgb(166, 216, 236) !important;
          text-decoration: underline;
        }

        .footer-link i.icon {
          margin-right: 0.5rem;
          font-size: 0.8rem;
        }

        .contact-info {
          color: rgba(255, 255, 255, 0.9);
        }

        .contact-item {
          display: flex;
          margin-bottom: 1.2rem;
          align-items: flex-start;
          font-size: 14px;
        }

        .contact-item i.icon {
          margin-right: 1rem;
          margin-top: 0.2rem;
          color: #87ceeb;
        }

        .contact-item a {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.9);
          text-decoration: none;
        }

        .contact-item a:hover {
          color: #87ceeb;
        }

        .footer-divider {
          border-color: rgba(255, 255, 255, 0.2) !important;
          margin: 0 !important;
        }

        .footer-bottom {
          background: #113355;
          padding: 0.5rem 0;
        }

        .copyright {
          color: rgba(255, 255, 255, 0.8);
          text-align: center;
          font-size: 0.7rem;
        }

        .copyright i.icon {
          margin-right: 0.5rem;
        }

        .social-section {
          text-align: right;
        }

        .social-links {
          display: flex;
          align-items: center;
          justify-content: fleAZz2x-end;
          gap: 1rem;
        }

        .follow-text {
          color: rgba(255, 255, 255, 0.8);
          margin-right: 0.5rem;
          font-size: 0.7rem;
        }

        .social-link {
          color: rgba(255, 255, 255, 0.7) !important;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
        }

        .social-link:hover {
          color: white !important;
          background: rgba(255, 255, 255, 0.2);
          transform: translateY(-2px);
        }

        /* Mobile Responsiveness */
        @media (max-width: 768px) {
          .footer-main {
            padding: 2rem 0 1.5rem 0;
          }

          .footer-header {
            font-size: 1.1rem !important;
            margin-bottom: 1rem !important;
          }

          .social-section {
            text-align: center !important;
            margin-top: 1rem;
          }

          .social-links {
            justify-content: center !important;
            flex-wrap: wrap;
          }

          .follow-text {
            width: 100%;
            text-align: center;
            margin-bottom: 0.5rem;
          }
        }

        @media (max-width: 480px) {
          .footer-main {
            padding: 1.5rem 0 1rem 0;
          }

          .contact-item {
            flex-direction: column;
            align-items: flex-start;
          }

          .contact-item i.icon {
            margin-bottom: 0.5rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
